import Axios, { type InternalAxiosRequestConfig } from 'axios';
import { API_URL } from '../const/constants';
import { STORAGE_KEYS } from '../hooks/useAuth';

export const axiosInstance = Axios.create({
	baseURL: API_URL,
});

axiosInstance.interceptors.request.use(
	// biome-ignore lint/suspicious/useAwait: <explanation>
	async (config: InternalAxiosRequestConfig) => {
		try {
			config.headers.Accept = 'application/json';
			config.withCredentials = true;

			return config;
		} catch (error) {
			return Promise.reject(error);
		}
	},
	(error) => {
		console.error('Error with request interceptor:', error);

		return Promise.reject(error);
	},
);

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response.status === 401) {
			localStorage.removeItem(STORAGE_KEYS.role);
			localStorage.removeItem(STORAGE_KEYS.organisation);
			localStorage.removeItem(STORAGE_KEYS.isAuth);

			window.location.href = '/login';
		} else if (error.response.status === 500) {
			window.location.href = '/error/500';
		}

		console.log(error.response.status);
	},
);

//switch to redux lol
